module.exports = __webpack_public_path__ + "6067f9290960de866d12e1d6d4f586ab.png";